module.exports = __webpack_public_path__ + "static/media/amenity_rooftop.16f2cc01.jpg";